// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"573":"4c02a02e","828":"92e9f04f","845":"66514fbf"}[chunkId] + ".chunk.css";
};